// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .MuiDataGrid-columnHeaderTitle {
  font-size: 14px !important;
  font-weight: 500 !important;
} */

/* .MuiDataGrid-root .MuiDataGrid-row {
  min-height: 60px !important;
} */

.revoke-access-button {
  background-color: #ffffff;
  border: 0px;
  border-radius: 4px;
  color: rgb(0, 0, 0);
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid black;
}

.revoke-access-button:disabled {
  background-color: #eeeeeeed;
  border: 0px;
  border-radius: 4px;
  color: rgb(135, 135, 135);
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid rgb(199, 199, 199);
  box-shadow: unset;
}

.revoke-access-button:disabled:hover {
  background-color: #eeeeeeed;
  border: 0px;
  border-radius: 4px;
  color: rgb(135, 135, 135);
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid rgb(199, 199, 199);
  box-shadow: unset;
}

.joined:hover {
  background-color: #DA291C;
  /* border: 0px; */
  border-radius: 4px;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
  border: 1px solid #DA291C;
}

.rejected:hover {
  background-color: #86BC25;
  border-radius: 4px;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
  border: 1px solid #86BC25;
}

.removed:hover {
  background-color: #86BC25;
  border-radius: 4px;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
  border: 1px solid #86BC25;
}

.table-cell-history {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 50px;
  font-size: 13px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrgHistory/OrgHistory.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B","sourcesContent":["/* .MuiDataGrid-columnHeaderTitle {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n} */\n\n/* .MuiDataGrid-root .MuiDataGrid-row {\n  min-height: 60px !important;\n} */\n\n.revoke-access-button {\n  background-color: #ffffff;\n  border: 0px;\n  border-radius: 4px;\n  color: rgb(0, 0, 0);\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid black;\n}\n\n.revoke-access-button:disabled {\n  background-color: #eeeeeeed;\n  border: 0px;\n  border-radius: 4px;\n  color: rgb(135, 135, 135);\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid rgb(199, 199, 199);\n  box-shadow: unset;\n}\n\n.revoke-access-button:disabled:hover {\n  background-color: #eeeeeeed;\n  border: 0px;\n  border-radius: 4px;\n  color: rgb(135, 135, 135);\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid rgb(199, 199, 199);\n  box-shadow: unset;\n}\n\n.joined:hover {\n  background-color: #DA291C;\n  /* border: 0px; */\n  border-radius: 4px;\n  color: white;\n  padding: 6px 12px;\n  font-size: 12px;\n  border: 1px solid #DA291C;\n}\n\n.rejected:hover {\n  background-color: #86BC25;\n  border-radius: 4px;\n  color: white;\n  padding: 6px 12px;\n  font-size: 12px;\n  border: 1px solid #86BC25;\n}\n\n.removed:hover {\n  background-color: #86BC25;\n  border-radius: 4px;\n  color: white;\n  padding: 6px 12px;\n  font-size: 12px;\n  border: 1px solid #86BC25;\n}\n\n.table-cell-history {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 50px;\n  font-size: 13px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
